import React, { useEffect, useState } from 'react';
import { RequestServer } from '../../utils/services';
import { APIRoutes } from '../../constants';
import PageLayout from '../../atoms/page-layout';
import MyDashboardsPageHeader from '../../molecules/app-bars/Mydashboards-page';
import { Box, Button, Divider, MenuItem, Select } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';

const DashboardPage = () => {
    const [dashboardEntries, setDashboardEntries] = useState<{ name: string; id: string; type: string; params: any }[]>([]);
    // selectedDashboard is the entry name key
    const [selectedDashboard, setSelectedDashboard] = useState<string>('');
    const [metabaseURL, setMetabaseURL] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [params] = useSearchParams();
    const fetchDashboardIds = async (adminId?: string) => {
        try {
            let url = APIRoutes.getDashboardIds;
            if (adminId) url = `${url}?user_id=${adminId}`;
            const response = await RequestServer(url, 'get');
            // Extract mapping object from possible wrappers (response, response.data, response.data.data)
            let dataObj: any = response;
            if (response && typeof response === 'object' && 'data' in response && response.data && typeof response.data === 'object') {
                dataObj = response.data;
            }
            if (dataObj && typeof dataObj === 'object' && 'data' in dataObj && dataObj.data && typeof dataObj.data === 'object') {
                dataObj = dataObj.data;
            }
            const entries = Object.entries(dataObj).map(([name, value]: any) => ({
                name,
                id: value.id,
                type: value.type,
                params: value.params,
                order: value.order || 0
            })).sort((a, b) => a.order - b.order);
            setDashboardEntries(entries);
            // Clear any prior fetch errors
            setError(null);

            // Determine default selection by name
            let defaultName = '';
            if (params.has('id')) {
                const idParam = String(params.get('id')); 
                const match = entries.find(e => e.id === idParam);
                defaultName = match ? match.name : entries[0]?.name;
            } else {
                defaultName = entries[0]?.name;
            }
            setSelectedDashboard(defaultName);
        }
        catch (error) {
            setError('Failed to fetch dashboard IDs');
        }
    };
    useEffect(() => {
        fetchDashboardIds(params.get('user_id') ?? '');
    }, []);

    const getMetabaseURL = async () => {
        if (!selectedDashboard) return;
        const entry = dashboardEntries.find(e => e.name === selectedDashboard);
        if (!entry) return;
        try {
            // Send full metabase object for selected entry
            const payload = { metabaseObject: { [selectedDashboard]: entry } };
            const response = await RequestServer(APIRoutes.getMetabaseURL, 'post', payload);
            setMetabaseURL(response.url);
            setError(null);
        } catch (error: any) {
            setError(error.message);
        }
    };
    useEffect(() => {
        if (selectedDashboard) {
            getMetabaseURL()
        }
    }, [selectedDashboard])

    return (
        <PageLayout>
            <MyDashboardsPageHeader
                selectedDashboard={selectedDashboard}
                setSelectedDashboard={setSelectedDashboard}
                dashboardEntries={dashboardEntries}
                getMetabaseURL={getMetabaseURL}
            />
              <Divider  />
            {dashboardEntries.length === 0 ? (
                <Box sx={{ mt: 6, textAlign: 'center', color: 'black', fontSize: '20px', fontWeight: 500, lineHeight: 1.2 }}>
                    No dashboards available....
                </Box>
            ) : metabaseURL ? (
                <Box sx={{ mt: 3 }}>
                    <iframe
                        src={metabaseURL}
                        title="Metabase Dashboard"
                        width="100%"
                        height="850vh"
                        style={{ border: '1px solid #ccc' }}
                    />
                </Box>
            ) : null}
        </PageLayout>
    );
};
export default DashboardPage;